var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M33.84 14.48H17.36a5.364 5.364 0 0 0-3.842 1.541 5.364 5.364 0 0 0-1.598 3.819v9.68a5.351 5.351 0 0 0 1.57 3.87 5.351 5.351 0 0 0 3.87 1.57h16.48a5.364 5.364 0 0 0 3.819-1.598A5.365 5.365 0 0 0 39.2 29.52v-9.68c0-2.96-2.4-5.36-5.36-5.36zM22.24 29.2v-8.96a.88.88 0 0 1 1.36-.8l7.52 4.48a.96.96 0 0 1 0 1.6L23.6 30a.88.88 0 0 1-1.36-.8z"
  }))));
};
export default SvgYoutube;